/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { AodNotificationSettingsSchema } from "./AodNotificationSettingsSchema";

export const AodRuleReportTypeEnum = {
    AUDIT_GIP_STATUS: "AUDIT_GIP_STATUS",
    AUDIT_GIP_ALTERNATIVE_REPORT: "AUDIT_GIP_ALTERNATIVE_REPORT",
    BCR_MATCHES: "BCR_MATCHES",
    LTX_MATCHES: "LTX_MATCHES"
} as const;

export type AodRuleReportTypeEnumKey = (typeof AodRuleReportTypeEnum)[keyof typeof AodRuleReportTypeEnum];

export const AodRuleTriggerEnum = {
    ORDER_END: "ORDER_END",
    EOW_AND_ORDER_END: "EOW_AND_ORDER_END"
} as const;

export type AodRuleTriggerEnumKey = (typeof AodRuleTriggerEnum)[keyof typeof AodRuleTriggerEnum];

export type AodRule = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    clientId: string;
    /**
     * @type string
    */
    name: string;
    /**
     * @type string
    */
    reportType: AodRuleReportTypeEnumKey;
    /**
     * @type object
    */
    reportConfig: object;
    /**
     * @type object
    */
    exportOptions: object;
    /**
     * @type object
    */
    exportConditions: object;
    /**
     * @type string
    */
    trigger: AodRuleTriggerEnumKey;
    /**
     * @type object
    */
    notificationSettings: AodNotificationSettingsSchema;
    /**
     * @type string | undefined
    */
    createdById?: string;
    /**
     * @type boolean
    */
    active: boolean;
    /**
     * @type array
    */
    managers: {
        /**
         * @type string | undefined
        */
        userId?: string;
    }[];
    /**
     * @type string | undefined
    */
    lastProcessedRunId?: string;
    /**
     * @type string, date-time
    */
    createdAt: string;
    /**
     * @type string, date-time
    */
    updatedAt: string;
};